import { resolveInputFontSize, resolvePadding } from './TextInputStyles';
import { useInterstateTheme } from '../InterstateThemeProvider';
import { clsx } from 'clsx';
import { useMemo } from 'react';
import { mergeSxStyle } from '../common/mergeSxStyle';
import { Box } from '../Box';
import { idBuilder, isValueFalsey } from '../internal';
import { jsx as _jsx } from "react/jsx-runtime";
export const TextInputReadOnly = _ref => {
  let {
    className,
    value,
    size,
    inputPrefix,
    inputSuffix,
    sx,
    id,
    ...rest
  } = _ref;
  const theme = useInterstateTheme();
  const effectiveClassName = useMemo(() => clsx(['ids-text-input-container', 'ids-text-input-readonly', className]), [className]);
  const readOnlyStyle = {
    fontFamily: theme.tokens.ComponentTextInputFontFamily,
    fontWeight: theme.tokens.ComponentTextInputFontWeight,
    display: 'flex',
    alignItems: 'center',
    fontSize: resolveInputFontSize(theme, size),
    color: theme.tokens.ComponentTextInputInputColor,
    fontVariationSettings: `"opsz" 16`,
    height: 'auto',
    padding: `${resolvePadding(size)} 0`
  };
  const effectiveStyle = mergeSxStyle(readOnlyStyle, sx);
  const _value = `${typeof inputPrefix === 'string' ? inputPrefix + ' ' : ''}${value || '\u2014'}${typeof inputSuffix === 'string' ? ' ' + inputSuffix : ''}`;
  return /*#__PURE__*/_jsx(Box, {
    sx: effectiveStyle,
    className: effectiveClassName,
    id: id || idBuilder('ids-readonly-input', ''),
    "data-testid": rest['data-testid'] || idBuilder('ids-readonly-input', ''),
    children: isValueFalsey(_value) ? '\u2014' : _value
  });
};